import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

type UserState = {
  userId: string | null;
  username: string | null;
  displayName: string | null;
};

const initialState: UserState = {
  userId: localStorage.getItem("userId"),
  username: localStorage.getItem("username"),
  displayName: "AweSM"
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<{ userId: string; username: string; displayName: string }>) {
      state.userId = action.payload.userId;
      state.username = action.payload.username;
      state.displayName = action.payload.displayName;
      localStorage.setItem("userId", action.payload.userId);
      localStorage.setItem("username", action.payload.username);
    },
    removeUser(state) {
      state.userId = null;
      state.username = null;
      state.displayName = null;
      try {
        localStorage.removeItem('userId');
        localStorage.removeItem('username');
      } catch {}
    }
  },
});

export const { setUser, removeUser } = userSlice.actions;
export default userSlice.reducer;

export const selectUserId = (s: RootState) => s.user.userId;
export const selectUsername = (s: RootState) => s.user.username;
export const selectDisplayName = (s: RootState) => s.user.displayName;
